/**
 * Created by hp on 2017/8/14.
 */
import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Mask} from 'react-weui';
import axios from 'axios';
import gfBgTop from '../../images/index-gift-dialog-top.png';
import gfBgMiddle from '../../images/index-gift-dialog-middle.png';
import gfBgBottom from '../../images/index-gift-dialog-bottom.png';

class MainGiftPopup extends Component {
    constructor() {
        super();
        this.handleHideGiftDialog = this.handleHideGiftDialog.bind(this);
        this.handleGetGift = this.handleGetGift.bind(this);

        this.state = {
            lectures: [],
        }
    }

    handleHideGiftDialog() {
        this.props.dispatch({type: 'MAIN_HIDE_GIFT_POPUP'});
    }

    handleGetGift() {
        const {account} = this.props;
        axios.get(`/api/channel/${account.gift_channel}/receive_gift?receive_from=click`).then(res => {
           if (res.data.code) {
               this.handleHideGiftDialog();
               this.context.page.showAlert(res.data.msg);
           }

           window.location = `/specials/${account.gift_channel}/gift/receive`;
        });
    }

    componentDidMount() {
        const {account} = this.props;
        if (account.can_receive_gift) {
            axios.get(`/api/channel/${account.gift_channel}/gift_lectures`).then(res => {
                if (res.data.code === 0) {
                    this.setState({lectures: res.data.data.lectures});
                    this.props.dispatch({type: 'MAIN_SHOW_GIFT_POPUP'});
                }
            });
        }
    }

    render() {
        const {lectures} = this.state;
        const {giftPopupShow} = this.props;

        if (!giftPopupShow) {
            return null;
        }

        return (
            <div className="main-gift-popup">
                <div className="mgp-container">
                    <Mask onClick={this.handleHideGiftDialog}/>
                    <div className="gf-bg-container">
                        <div className="gf-bg-top">
                            <img src={gfBgTop}/>
                        </div>
                        <div className="gf-bg-middle">
                            <img src={gfBgMiddle}/>
                            <div className="gfm-container">
                                {lectures.map((lecture) => (
                                    <div className="gift-item weui-flex" key={lecture.id}>
                                        <div className="weui-flex__item gift-text">
                                            <p className="text-ellipsis-newline lecture">{lecture.name}</p>
                                            <ul>
                                                <li className="li-lecture-name">{lecture.liveroom_name}</li>
                                                <li className="li-lecture-popular">{lecture.popular}人气</li>
                                            </ul>
                                        </div>
                                        <div className="weui-flex__item gift-pic">
                                            <img src={lecture.avatar} alt=""/>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                        <div className="gf-bg-bottom">
                            <img src={gfBgBottom}/>
                            <i className="iconfont icon-cuowu" onClick={this.handleHideGiftDialog}/>
                            <div className="btn-get" onClick={this.handleGetGift}></div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

MainGiftPopup.contextTypes = {
    mainPage: React.PropTypes.object,
    page: React.PropTypes.object
};

export default connect((state) => ({
    account: state.main.account,
    giftPopupShow: state.main.giftPopupShow,
}))(MainGiftPopup)


// WEBPACK FOOTER //
// ./src/components/main/MainGiftPopup.js